import { render, staticRenderFns } from "./lawsDetail.vue?vue&type=template&id=eb1058a2&scoped=true"
import script from "./lawsDetail.vue?vue&type=script&lang=js"
export * from "./lawsDetail.vue?vue&type=script&lang=js"
import style0 from "./lawsDetail.vue?vue&type=style&index=0&id=eb1058a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1058a2",
  null
  
)

export default component.exports